var _window$BRICK_NEXT_VE;
// istanbul ignore file
// Make v3 bricks compatible with Brick Next v2.
import * as HttpModuleV3 from "./exports.js";
let HttpModule;
let HttpModuleV2;
const {
  dll
} = window;
if (dll && (_window$BRICK_NEXT_VE = window.BRICK_NEXT_VERSIONS) !== null && _window$BRICK_NEXT_VE !== void 0 && (_window$BRICK_NEXT_VE = _window$BRICK_NEXT_VE["brick-container"]) !== null && _window$BRICK_NEXT_VE !== void 0 && _window$BRICK_NEXT_VE.startsWith("2.") && (HttpModuleV2 = dll("JxWY"))) {
  HttpModule = HttpModuleV2;
} else {
  HttpModule = HttpModuleV3;
}
const {
  fetch,
  HttpFetchError,
  HttpResponseError,
  HttpParseError,
  HttpAbortError,
  http,
  isHttpAbortError,
  createHttpInstance,
  defaultAdapter
} = HttpModule;
export { fetch, HttpFetchError, HttpResponseError, HttpParseError, HttpAbortError, http, isHttpAbortError, createHttpInstance, defaultAdapter };
//# sourceMappingURL=index.js.map